define('views/components/metrik_user/metrik_user_list',['require','views/base/list_view','views/components/metrik_user/metrik_user','text!templates/components/metrik_user/metrik_user_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/metrik_user/metrik_user');

    var temp = require("text!templates/components/metrik_user/metrik_user_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

